export default "__VITE_ASSET__036f00cb__"